import { useMutation } from '@tanstack/react-query'
import { instance } from '../instance'

export const useDelete = () => {
  const deleteService = async (serviceName: string, serviceId: string) => {
    const response = await instance.delete(
      `/admin-dashboard/${serviceName}/${serviceId}`,
    )
    return await response.data
  }

  const deleteMutation = useMutation({
    mutationFn: (props: { serviceName: string; serviceId: string }) =>
      deleteService(props.serviceName, props.serviceId),
    mutationKey: ['Delete '],
  })
  return deleteMutation
}
